module.exports = __webpack_public_path__ + "img/register_mb_05.454407c4.png";